import container from "@/lib/di/container";
import { useState, useEffect } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType, handleAddressChange } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "../../components/table/DataTable";
import { DetailModal } from "./modals/DetailModal";
import { Button, Dropdown, message, Tooltip } from "antd";
import { InfoCircleOutlined, LockOutlined, MoreOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { AppUserModel, AppUserModelFactory } from "@/core/models/app-user.model";
import { AppUserRepo } from "@/core/repos/tables/app-user.repo";
import { activeStatusPipe } from "@/core/pipes/active-status.pipe";
import AuthRepo from "@/core/repos/auth.repo";
import { DeleteButton } from "../../components/table/DeleteButton";
import { AppRoleModal } from "./modals/AppRoleModal";
import { ChangePasswordModal } from "./modals/ChangePasswordModal";
import { GlobalUtils } from "../../utils/global.utils";
import { PERMISSIONS } from "@/core/enums/permissions.enum";

const appUserRepo = container.get(AppUserRepo);
const authRepo = container.get(AuthRepo);

export default function AccountsPage() {
    const titleData = useTitleDataStore();
    const userDetail = authRepo.useDetails();
    const claims = authRepo.useClaims();
    const [modalData, setModalData] = useState<AppUserModel>(AppUserModelFactory.getEmpty())
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map())
    const [selectedRows, setSelectedRows] = useState<AppUserModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [isRoleModal, setRoleModal] = useState(false);
    const [isChangePasswordModal, setChangePasswordModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates, setFilterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tên tài khoản",
            placeholder: "Nhập tên tài khoản",
            type: FilterInputType.text,
        },
    ])

    useEffect(() => {init()}, []);

    const init = async () => {
        await authRepo.getUserData();
    }

    useEffect(()=>{
        titleData.setTitleActions({
            text: "Tạo tài khoản mới",
            onPress: () => {
                showDetail(AppUserModelFactory.getEmpty(userDetail?.waterFactoryId))
            }
        })
    }, [userDetail])



    async function onFilterChange(map: Map<string, FilterSearchPayload>, changes: string[]) {
        await handleAddressChange(map, changes, filterTemplates, setFilterTemplates);
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: AppUserModel[]) {
        setSelectedRows([...rows]);
    }

    const showDetail = (record: AppUserModel) => {
        setModalData(record);
        setDetailModal(true);
    };

    const showRole = (record: AppUserModel) => {
        setModalData(record);
        setRoleModal(true);
    };

    const showChangePassword = (record: AppUserModel) => {
        setModalData(record);
        setChangePasswordModal(true);
    };

    const deleteSelected =  async () => {
        setDeleting(true);
        const result = await appUserRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }

    return (
    <div className="px-4 py-6">
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="mt-6">
                <DeleteButton loading={deleting} length={selectedRows.length} onConfirm={deleteSelected}/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<AppUserModel>
                columns={[
                    { dataIndex: 'userName', name: 'Tài khoản'},
                    { dataIndex: 'fullName', name: 'Họ và tên'},
                    { dataIndex: 'title', name: 'Chức vụ'},
                    { dataIndex: 'isActive', name: 'Trạng thái', pipe: activeStatusPipe},
                    {
                        name: 'Thao tác',
                        width: 100,
                        render: (_, record) => (
                                <div className="flex flex-row px-1 items-center justify-center">
                                    <Tooltip title="Sửa bản ghi"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                                    <Dropdown menu={{items: [
                                            {
                                                key: '1',
                                                label: <p>Phân quyền</p>,
                                                icon: <UsergroupAddOutlined />,
                                                onClick: () => showRole(record)
                                            },
                                            // {
                                            //     key: '2',
                                            //     label: <p>Cấp quyền Admin</p>,
                                            //     icon: <KeyOutlined />
                                            // },
                                            ...(GlobalUtils.checkPerm(claims, PERMISSIONS.ACCOUNT_CHANGEPASSWORD.key)?[{
                                                key: '3',
                                                label: <p>Đổi mật khẩu</p>,
                                                icon: <LockOutlined />,
                                                onClick: () => showChangePassword(record)
                                            }]: []),
                                        ]}} trigger={["hover"]}>
                                            <Button type="text" icon={<MoreOutlined />}/>
                                        </Dropdown>
                                </div>
                            ),
                        fixed: "right"
                    },
                ]}
                repository={appUserRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
        <AppRoleModal isModalOpen={isRoleModal} setIsModalOpen={setRoleModal} data={modalData}></AppRoleModal>
        <ChangePasswordModal isModalOpen={isChangePasswordModal} setIsModalOpen={setChangePasswordModal} data={modalData}></ChangePasswordModal>
    </div>)
}